import { TrashIcon } from '@radix-ui/react-icons'
import { useRolodexEdit } from 'features/fde'
import { useKestrel } from 'features/kestrelViewer'
import React, { FC } from 'react'
import styled from 'styled-components'
import { KVAnnotation, RolodexEntryPatchJson } from 'types'

const StyledTrashIcon = styled(TrashIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

export const DeleteAnnotationButton: FC<{
  annotationId: string
}> = ({ annotationId }) => {
  const {
    sendKVCommand,
    selectedMarkup,
    setSelectedMarkup,
    kestrelModel,
    annotations,
    setAnnotations,
  } = useKestrel()
  const { rolodexPatch } = useRolodexEdit()

  const deleteAnnotation = (e: React.MouseEvent) => {
    e.stopPropagation()
    let filteredAnnotations: KVAnnotation[] = []
    if (annotations) {
      filteredAnnotations = annotations.filter((a) => a.id !== annotationId)
    }
    if (sendKVCommand) {
      setAnnotations(filteredAnnotations)
      sendKVCommand({
        command: 'deleteAnnotation',
        annotationId: annotationId,
      })
      if (selectedMarkup?.id === annotationId) setSelectedMarkup(undefined)

      // Delete from Rolodex
      const patchData: RolodexEntryPatchJson = {
        id: kestrelModel?.id ?? '',
        data: {
          annotations:
            filteredAnnotations?.map((a) => KVAnnotation.toJSON(a)) ?? [],
        },
      }
      rolodexPatch([patchData])
    }
  }

  return (
    <div
      style={{ cursor: 'pointer', marginLeft: '-4px' }}
      onClick={(e) => deleteAnnotation(e)}>
      <StyledTrashIcon width={22} height={22} />
    </div>
  )
}
